import type { PageTabs as Tabs } from '../../lib/pagetabs.js';
import { Icon } from '../ui/Icon.js';

/**
 * The open pages along the top bar (lib/pagetabs.ts): click one to go back to it as it was, the
 * x or a middle click to close it. The last one stays: there is always a page showing, and its
 * tab says which.
 */
export function PageTabs({ tabs, labelFor }: { tabs: Tabs; labelFor: (key: string) => string }) {
  if (tabs.tabs.length === 0) return <div className="arc-ptabs" />;
  const only = tabs.tabs.length === 1;
  return (
    <nav className="arc-ptabs" aria-label="Open pages">
      {tabs.tabs.map((t) => {
        const label = labelFor(t.key);
        const active = t.key === tabs.current;
        return (
          <div key={t.key} className="arc-ptab" data-active={active}
            // Middle click closes, as in a browser; its own autoscroll would start otherwise.
            onMouseDown={(e) => { if (e.button === 1 && !only) e.preventDefault(); }}
            onAuxClick={(e) => { if (e.button === 1 && !only) tabs.close(t.key); }}>
            <button type="button" className="arc-ptab-label" title={label}
              aria-current={active ? 'page' : undefined} onClick={() => tabs.show(t.key)}>
              {label}
            </button>
            {!only && (
              <button type="button" className="arc-ptab-x" aria-label={`Close ${label}`}
                title="Close" onClick={() => tabs.close(t.key)}>
                <Icon name="close" size={12} />
              </button>
            )}
          </div>
        );
      })}
    </nav>
  );
}
